export const isString = (maybeString: unknown): maybeString is string => typeof maybeString === "string";
